/**
 * Keyboard shortcut configurations for different UI interactions
 *
 * These shortcuts can be used with hooks like `useSearchKeyboardShortcut`
 * to provide consistent keyboard navigation across the application.
 */

/**
 * Search input keyboard shortcuts
 * Used to quickly focus search inputs throughout the application
 */
export const SEARCH_SHORTCUTS = {
  /** Forward slash - most common search shortcut (e.g., GitHub, Slack) */
  SLASH: "/",
} as const;

/**
 * Predefined shortcut combinations for common use cases
 */
export const KEYBOARD_SHORTCUTS = {
  /** Default search shortcut - uses forward slash */
  SEARCH_DEFAULT: [SEARCH_SHORTCUTS.SLASH],
} as const;

/**
 * Type for search shortcut keys
 */
export type SearchShortcut = (typeof SEARCH_SHORTCUTS)[keyof typeof SEARCH_SHORTCUTS];

/**
 * Type for keyboard shortcut arrays
 */
export type KeyboardShortcutArray = Array<string>;
